import React, { memo } from 'react'
import { useNavigate } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { StatusTag } from '../../components/common/StatusTag'
import { VerifiedUser } from 'iconoir-react'
import { useTheme } from '@mui/material'
import { PROPOSAL_TYPE, TYPE_STATUS } from '../../utils/constants'

const ProposalSalaryRequestTable = props => {
  const navigate = useNavigate()
  const theme = useTheme()
  const item = props.data

  const upperCase = inputString => {
    const words = inputString.split(' ')
    const capitalizedWords = []
    for (const word of words) {
      const capitalizedWord = word.charAt(0).toUpperCase() + word.slice(1)
      capitalizedWords.push(capitalizedWord)
    }
    const resultString = capitalizedWords.join(' ')
    return resultString
  }

  return (
    <div
      onClick={() => {
        navigate(`/proposal-salary-request/view/${item.proposal_code}`)
      }}
      style={{
        backgroundColor: '#ffffff',
        padding: '5px',
        margin: ' 15px auto',
        borderRadius: '10px',
        boxShadow: theme.boxShadow.boxShadow1,
      }}>
      <div style={{ minHeight: '70px', margin: '0 5px 0 5px' }}>
        <div className="text-[16px] ml-4">{item.title}</div>
        <div className="flex justify-between pl-4 pt-4">
          <div className="flex font-bold text-xs items-center text-[#2C65B1]">
            <VerifiedUser className="mr-1 text-[10px] -mt-1" />
            <div>{upperCase(item.create_user.user_name)}</div>
          </div>
          <div className="w-1/2 flex justify-end items-start">
            <StatusTag
              typePage={TYPE_STATUS.PROPOSAL}
              status={item.proposal_status}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default memo(
  inject('proposalStore')(observer(ProposalSalaryRequestTable))
)
